import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import JobExperinceForm from '../FormComponents/JobExperinceForm';
import { Fields } from '../styles';

export const AddButton = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid #d6dce2;
  border-radius: 22px;
  background-color: #f4f5f7;
  padding: 10px 30px;
  color: #252525;
  font-family: acumin-pro;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 19px;
  cursor: pointer;
  span {
    flex-grow: 1;
  }
  svg {
    height: 21px;
    color: #0a4ea2;
    font-size: 21px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 21px;
    text-align: right;
  }
`;

const Phase3 = ({
  values,
  setValue,
  nextForm,
}: {
  values: { [key: string]: any };
  setValue: Function;
  nextForm: () => void;
}) => {
  const { t } = useTranslation();
  const addBlankJobExperience = () => {
    const newJobExperiences = [...(values.jobExperiences || [])];
    newJobExperiences.push({
      id: Date.now(),
      employer: '',
      startMonth: new Date().getMonth() + 1,
      startYear: new Date().getFullYear(),
      endMonth: new Date().getMonth() + 1,
      endYear: new Date().getFullYear(),
      workAssignment: '',
    });
    setValue('jobExperiences', newJobExperiences);
  };
  const renderJobExperiences = () =>
    (values.jobExperiences || []).map((jb: any, index: number) => (
      <JobExperinceForm
        key={jb.id}
        experience={jb}
        deleteExperience={() => {
          const newJobExperiences = values.jobExperiences.filter(
            (jb2: any, index2: number) => index !== index2,
          );
          setValue('jobExperiences', newJobExperiences);
        }}
        onChange={(newJb: any) => {
          const newJobExperiences = [...values.jobExperiences];
          newJobExperiences[index] = newJb;
          setValue('jobExperiences', newJobExperiences);
        }}
      />
    ));
  return (
    <Fields>
      <div className="rows">
        {renderJobExperiences()}
        <AddButton onClick={addBlankJobExperience}>
          <span>{t('add-new-job-experience')}</span>{' '}
          <FontAwesomeIcon icon={['fal', 'plus-circle']} />
        </AddButton>
      </div>
      <div className="additional-info">
        <div className="selection-details">
          {(values.jobExperiences || []).length > 0 ? (
            <>
              <label>{t('added-job-experiences')}</label>
              {values.jobExperiences.map((jb: any, i: number) => {
                const employer = jb.employer || t('untitled-employer');
                const workAssignment =
                  jb.workAssignment || t('untitled-assignment');
                const startStr =
                  jb.startMonth && jb.startYear
                    ? `${jb.startMonth}/${jb.startYear}`
                    : null;
                const endStr =
                  jb.endMonth && jb.endYear
                    ? `${jb.endMonth}/${jb.endYear}`
                    : null;
                const dateRange =
                  startStr && endStr ? `${startStr} - ${endStr}` : startStr;
                const experienceString = [employer, workAssignment, dateRange]
                  .filter((str: string | null) => str)
                  .join(', ');
                return (
                  <div
                    className="work-exp-side"
                    onClick={() => {
                      const newJobExperiences = values.jobExperiences.filter(
                        (jb2: any, i2: number) => i2 !== i,
                      );
                      setValue('jobExperiences', newJobExperiences);
                    }}
                  >
                    <span>{experienceString}</span>
                    <FontAwesomeIcon icon={['fal', 'times-circle']} />
                  </div>
                );
              })}
            </>
          ) : null}
        </div>
        <button type="button" onClick={nextForm}>
          {t('next')}
        </button>
      </div>
    </Fields>
  );
};

export default Phase3;
